import usePropertyRateTierProgression from 'loyalty/hooks/usePropertyRateTierProgression'
import useUserTierProgress from 'loyalty/hooks/useUserTierProgress'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import TierProgressionBanner from './TierProgressionBanner'
import { OptimizelyExperiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'

interface Props {
  className?: string
  property: App.Property.Property | undefined
  rates: Array<App.EnrichedPropertyRate>
  nights: number
  checkoutDate?: string
  isUltraLux?: boolean
}

function PropertyTierProgressionPanel({ className, property, rates, nights, checkoutDate, isUltraLux }: Props) {
  const {
    showTierProgressionBanner,
    lowestUnlockableTier,
    lowestUnlockableTierName,
    highestUnlockableTier,
    highestUnlockableTierName,
    hasMultipleTierJumps,
    isLoading,
    membershipYearEndDate,
  } = usePropertyRateTierProgression({
    property,
    rates,
    nights,
    checkoutDate,
    isUltraLux,
    skip: rates.length === 0 || nights <= 0,
  })

  const canActivateTierProgressionExperiment = showTierProgressionBanner && !isLoading
  const { isAnyVariant: isTierProgressionExperimentVariant } = useExperiment(
    OptimizelyExperiments.croTierProgressionOfferPage,
    { canActivate: canActivateTierProgressionExperiment },
  )

  const { creditsNeeded, nightsNeeded } = useUserTierProgress()

  if (!canActivateTierProgressionExperiment || !isTierProgressionExperimentVariant || isLoading || !showTierProgressionBanner) {
    return null
  }

  return (
    <TierProgressionBanner
      className={className}
      lowestUnlockableTier={lowestUnlockableTier}
      lowestUnlockableTierName={lowestUnlockableTierName}
      highestUnlockableTier={highestUnlockableTier}
      highestUnlockableTierName={highestUnlockableTierName}
      hasMultipleTierJumps={hasMultipleTierJumps}
      statusCreditsNeeded={creditsNeeded}
      nightsNeeded={nightsNeeded}
      membershipYearEndDate={membershipYearEndDate}
      checkoutDate={checkoutDate}
    />
  )
}

export default withMountGuard(() => {
  return useAppSelector(getIsCurrentRegionUserLoyaltyRegion)
})(PropertyTierProgressionPanel)
